module.exports = __webpack_public_path__ + "static/media/MCAP-V_2.a05c32f8.PDF";